<template>
  <q-btn
    @click="$emit('click')"
    :class="invisible ? ' invisible' : ''"
    :color="color"
    flat
    round
    dense
    :icon="icon"
  />
</template>

<script>
import mixin from "./d-card-mixins";
export default {
  name:'DCardToolbarButton',
  mixins: [mixin],
  props: {
    invisible: {
      type: Boolean,
      value: false
    },
    color: {
      type: String,
      value: ''
    },
    icon: {
      type: String,
      value: ''
    }
  }
}
</script>